import i18n from "i18n"
export const DATE_FORMAT = "MM/DD/YYYY"

export const SEASON_TYPES = {
  ALL_YEAR: "all-year",
  SEASONAL: "seasonal"
}

export const DATE_PICKER_PROPS = {
  autoComplete: "new-password",
  autoFill: "off",
  "data-form-type": "date"
}

export const DAYS = [
  { value: "sunday", label: i18n.t("experiences.days.sun") },
  { value: "monday", label: i18n.t("experiences.days.mon") },
  { value: "tuesday", label: i18n.t("experiences.days.tue") },
  { value: "wednesday", label: i18n.t("experiences.days.wed") },
  { value: "thursday", label: i18n.t("experiences.days.thu") },
  { value: "friday", label: i18n.t("experiences.days.fri") },
  { value: "saturday", label: i18n.t("experiences.days.sat") }
]
